import { TempoInput } from "src/components/TempoInput";
import { useWorkoutItemSetContext } from "src/workouts/WorkoutItemSetContext";

export function TempoExerciseAttribute() {
  const workoutItemSetContext = useWorkoutItemSetContext();

  return (
    <TempoInput
      disabled={workoutItemSetContext.isEditableInputDisabled()}
      value={workoutItemSetContext.getEditableValue()}
      onChange={(value) => {
        workoutItemSetContext.updateEditableValue(value);
      }}
    />
  );
}
